import React from 'react'
import HeaderOne from "../components/header/HeaderOne";

import CallToActionThree from '../components/calltoaction/CallToActionThree';
import PrimaryFooter from '../components/footer/PrimaryFooter';
import AviationBreadcrumb from '../inner/AviationBreadcrumb';
import AviationSidebar from './AviationSidebar';

const AircraftSalePurchaseLease = () => {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Aircraft Purchase, Sale & Leasing' }
    ];
  return (
   <>    
   
<div className=''>
<HeaderOne />
<AviationBreadcrumb title="Aircraft Purchase, Sale & Leasing" breadcrumbs={breadcrumbs} />

{/* start service details area */}
<div className="rts-service-details-area rts-section-gap">
    <div className="container">
        <div className="row">
        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                <div className="service-detials-step-1">
                    <div className="thumbnail">
                    <img src="assets/images/aircraft-purchase-sale-leasing.jpg" alt="Supply Chain Management" />
                    </div>
                    <h4 className='title'> Aircraft Purchase, Sale & Leasing </h4>
                    <p> “Service with Trust”. At P.A.S. we specialize in aircraft purchase, sale, and leasing services with a commitment to excellence and global reach. 
                        Whether you're acquiring a new jet, selling your aircraft, or exploring flexible leasing options, our expert team ensures a seamless and professional experience. 
                        Trust us to deliver tailored solutions that meet your aviation needs. </p>
                   
                   </div>  
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                <AviationSidebar />
</div>



<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center mt-5">
<h4 className="title text-center"> Our Services </h4>
            </div> 

            <div className="col-lg-4 col-md-4 col-12">
    <div className='description'>
     <h5> Aircraft Purchase Assistance </h5>
       <ul>
        <li> End-to-end guidance for buying private, commercial, or cargo aircraft. </li>
        <li> Market analysis and valuation for the best pricing. </li>
        <li> Pre-purchase inspections and regulatory compliance support. </li>
       </ul>
       </div> 
   </div>


   <div className="col-lg-4 col-md-4 col-12">
    <div className='description'>
     <h5> Aircraft Sales & Brokerage </h5>
       <ul>
        <li> Global network to connect sellers with potential buyers. </li> 
        <li> Professional marketing and listing services. </li>
        <li> Negotiation and documentation handling for smooth transactions. </li>
       </ul>
       </div> 
   </div>

   <div className="col-lg-4 col-md-4 col-12">
    <div className='description'>
     <h5> Aircraft Appraisal & Documentation </h5>
       <ul>
        <li> Aircraft valuation for fair market pricing. </li>
        <li> Regulatory compliance, ownership transfer, and tax advisory. </li>
       </ul>
       </div> 
   </div>


   <div className="col-lg-4 col-md-4 col-12">
    <div className='description'>
     <h5> Aircraft Leasing Solutions </h5>
       <ul>
        <li> <b> Operating Leases </b> Short-term leasing without ownership risks. </li>
        <li> <b> Finance Leases </b>  Structured leasing with ownership options. </li>
        <li> <b> Wet & Dry Leasing </b>  Crew-included (wet) or aircraft-only (dry) leasing. </li>
        <li> Fleet expansion and short-term operational solutions for airlines. </li>
       </ul>
       </div> 
   </div>


        </div>


        <div className="row mt-5">
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="service-detials-step-1">
                    <div className="thumbnail">
                    <img src="assets/images/sale-purchase-lease.jpg" alt="Supply Chain Management" />
                    </div>
                   </div>  
            </div>

            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="service-detials-step-1 industries">
                    <h4 className="title pt-5"> Why Choose Planetronix Aviation? </h4>
                    <ul>
                        <li> <b> Industry Expertise </b>  Decades of experience in aviation transactions.  </li>
                        <li> <b> Global Market Reach </b>  Access to aircraft buyers, sellers, and lessors worldwide  </li>
                        <li> <b> End-to-End Support </b>  From negotiations to paperwork and delivery.  </li>
                        <li> <b> Customized Leasing Plans </b>  Flexible solutions for commercial and private operators.  </li>
                    </ul>
                </div>  
            </div>
        </div>
    </div>
</div>
{/* End service details area */}



<CallToActionThree />
<PrimaryFooter />
</div>    
   
   
   
   </>
  )
}

export default AircraftSalePurchaseLease